module.exports = __webpack_public_path__ + "static/img/activity_sdy_04-3.b989ea8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_04-3.jpg
// module id = 97tU
// module chunks = 0